(function () {

  'use strict';

  angular.module('specsguardApp')
    .run(appRun);

  appRun.$inject = ['$rootScope', '$state', 'Auth', 'amMoment', '$transitions', 'errorMessageService',
    '$timeout', 'Constants', 'Labels', 'Help', 'Menu', 'updateNotifier', 'ProjectStateManagerService'];

  function appRun ($rootScope, $state, Auth, amMoment, $transitions, errorMessageService,
    $timeout, Constants, Labels, Help, Menu, updateNotifier, ProjectStateManagerService) {
    // change angular moment to dutch
    amMoment.changeLocale('nl');

    updateNotifier.init();

    ProjectStateManagerService.init();

    /**
     * Intercept front-end route changes to check for auth and rights
     * */

    // UI-Router > 1.0.0 has deprecated state events such as $stateChangeStart
    // it has been replaced by the $transitions service
    $transitions.onStart({}, function (trans) {
      const toState = trans.$to();
      const isLoggedIn = Auth.isLoggedIn();

      toState.needRole = angular.isDefined(toState.needRole) ? toState.needRole : 0;

      // if there is a redirectTo property on the state definition, directly redirect first!
      if (toState.redirectTo) {
        return trans.router.stateService.target(toState.redirectTo);
      }

      // redirect to login when not logged in and auth is required
      if (toState.redirectTo && !isLoggedIn) {
        return trans.router.stateService.target('login');
      }

      const currentUserRole = angular.isDefined(Auth.getCurrentUserRole()) ? Auth.getCurrentUserRole().accessLevel : 0;

      // redirect to login when user has not enough rights
      if (currentUserRole < toState.needRole && toState.authenticate) {
        errorMessageService.showWarning('Niet genoeg toegangsrechten');
        return trans.router.stateService.target('login');
      }

      if (isLoggedIn) {
        if (!Constants.getAll() || !Help.getAll() || !Labels.getAll() || !Menu.getAll()) {
          return Promise.all([
            Menu.getMenu(),
            Constants.getConstants(),
            Labels.getLanguages(),
            Help.getHelp(),
          ]);
        }
      }

      return null;
    });

    /**
     * Event listeners for error messages (from resources)
     * */

    // TODO see if we can refactor emitting/listening on rootScope to listening on $http
    $rootScope.$on('showError', function (event, msg) {
      errorMessageService.showError(msg);
    });

    $rootScope.$on('showWarning', function (event, msg) {
      errorMessageService.showWarning(msg);
    });
  }
})();
